import {useActions, useGetters, useMutators, useState} from './_map';
import {MAP_OBJECT_TYPE_HISTORY_ARROW} from "@/js/constants";
import HistoryPopup from "@/js/Components/MapPopup/HistoryPopup.vue";
export default {
    namespaced: true,
    state: {
        ...useState(),
        name: MAP_OBJECT_TYPE_HISTORY_ARROW,
        popupComponent: HistoryPopup,
    },
    getters: {
        ...useGetters(),
        icon: state => state.icon,
        layer: state => state.layer,
    },
    mutations: {
        ...useMutators(),
    },
    actions: {
        ...useActions(),
    },
}
